module.exports = __webpack_public_path__ + "img/bulang2.15c0211d.png";